var success = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-04-26 13:36:49',
    type: 'LOAN_EDIT',
    data: {
        loanId: 1,
        status: 'AGREED',
        providerRequest: 'requested',
        stage: 2,
    },
};
export var loanEditMock = {
    success: success,
};
